import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@material-ui/core";
import styles from "./MapPopupStyles.js";
import "./style.scss";
import {formatAddress} from "../../modules/Dispatch/utils/utils"
import { getFormattedDefaultHours } from "../../modules/CustomerManagement/EditCustomer/utils.js";

function CustomerPopup(props){
  const { classes, theme, data } = props;
  const address = formatAddress({
    address: `${data.address} ${data.address2 ?? ""}`.trim(),
    city: data.city,
    state: data.state,
    zip: data.zip
  });
  return(
    <Paper className={`${classes.routeStop} popupBGColor`}>
      <Table className={classes.table} padding="none">
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.tableHeadHeight}>
            <TableCell colSpan={2} className={classes.tableHeaderCell}>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={props.data.name ?? ""}>
                <div className={classes.customerName}>
                  {props.data.name}
                </div>
              </Tooltip>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={props.data.routeName ??""}>
                <span className={classes.routeInfo}>
                  {props.data.deliveryDetails?.route ?? ""}
                </span>
              </Tooltip>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={address ??""}>
                <div className={classes.address}>{address}</div>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}>Service Window</TableCell>
            <TableCell className={`${classes.dataCell} tableCellValue`}>
            {
              getFormattedDefaultHours(props.data.deliveryDetails ?? props.data.pickupDetails).map((deliverySlot, index) => <React.Fragment key={index}><span>{deliverySlot}</span><br /></React.Fragment>)
            }
            </TableCell>
          </TableRow>
          {props.data.deliveryDetails?.specialInstruction &&
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}>Special Instructions</TableCell>
            <TableCell className={`${classes.dataCell} ${classes.lastTableCell} tableCellValue`}>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={props.data.deliveryDetails?.specialInstruction}>
                <div className={classes.SpecialInstruction}>{props.data.deliveryDetails?.specialInstruction}</div>
              </Tooltip>
            </TableCell>
          </TableRow>}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default withStyles(styles)(CustomerPopup);